// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"72aa6cc5","703":"2c74f979","787":"f8519bd2"}[chunkId] + ".chunk.js";
};